
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';

interface DiagnosticInfoProps {
  diagnosticInfo: any;
}

const DiagnosticInfo: React.FC<DiagnosticInfoProps> = ({ diagnosticInfo }) => {
  if (!diagnosticInfo) return null;

  return (
    <Alert className="border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/20 mb-4">
      <AlertCircle className="h-4 w-4 text-amber-600 dark:text-amber-400" />
      <AlertTitle className="text-amber-700 dark:text-amber-300">Диагностическая информация</AlertTitle>
      <AlertDescription className="text-amber-600 dark:text-amber-400">
        <details>
          <summary className="cursor-pointer">Показать детали</summary>
          <pre className="text-xs overflow-auto max-h-60 mt-2 p-2 rounded bg-white dark:bg-black/20">
            {JSON.stringify(diagnosticInfo, null, 2)}
          </pre>
        </details>
      </AlertDescription>
    </Alert>
  );
};

export default DiagnosticInfo;
